declare const require: any;

export const environment = {
    production: true,
    name: 'staging',
    version: require( '../../package.json' ).version,
    azure: {
        appRedirectUri: 'https://scope.riege.cloud',
        apiScopeUri: 'https://scopeidentityfat.onmicrosoft.com/connect-backend/backend-access',
        authorityDomain: 'scopeidentityfat.b2clogin.com',
        authoritySigninUrl: 'https://scopeidentityfat.b2clogin.com/scopeidentityfat.onmicrosoft.com/b2c_1a_rsisignin',
        authoritySignupUrl: 'https://scopeidentityfat.b2clogin.com/scopeidentityfat.onmicrosoft.com/b2c_1a_rsisignup',
        clientId: '6831145b-7d6f-4ac9-a13a-d31028ff01b4',
        connectDomain: 'FAT',
        applicationInsights:
            'InstrumentationKey=da24f381-4764-4ebc-906d-648b42ce0511;IngestionEndpoint=https://germanywestcentral-1.in.applicationinsights.azure.com/;LiveEndpoint=https://germanywestcentral.livediagnostics.monitor.azure.com/;ApplicationId=9b590948-0f39-4aa3-9724-0c7464cefff6'
    },
    api: {
        identityApi: 'https://api-staging.riege.com/scope-identity-service',
        registrarApi: 'https://api-staging.riege.com/registrar',
        scopeApi: 'https://api-staging.riege.com/scope',
        agentsApi: 'https://api-staging.riege.com/agent-service/api/1.0',
        unlocodeApi: 'https://api-staging.riege.com/unlocode-service',
        impostApi: 'https://api-staging.riege.com/atlas-impost-server',
        exchangeApi: 'https://api-staging.riege.com/exchange-rate-service/v1'
    },
    keys: {
        matomo: '7',
        maptiler: 'ipxDBvrUPbIrYu6bfM5Q',
        unlocode: 'fNuGhvltNCmAhKAPL6g9Z08Nh1yxprqHHlX53pv7O825BSqi36'
    },
    rssFeeds: {
        domain: 'https://www.riege.com/_hcms/api/feed'
    },
    optionalModules: {
        showMatomoConsent: true,
        showCommunityMap: true,
        showUnLocodes: true,
        showUserAdmin: false,
        showStyleGuide: false,
        showOrganization: true,
        showGermanCustoms: true,
        showSwissCustoms: false,
        switchTenants: false,
        showHostRegions: true,
        showScopeCommunity: false,
        showExchangeCalculator: true
    }
};
